module.exports = __webpack_public_path__ + "img/detroit.9085bfac.png";